import React, { useEffect, useState, useRef } from "react";
import {
  makeStyles,
  Grid,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  Hidden,
  IconButton,
  Box,
  Menu,
  MenuItem,
} from "@material-ui/core";
// import { downloadExcel } from "react-export-table-to-excel";
import { Search as SearchIcon } from "react-feather";
import { TextField } from "./";
import { simpleToolbarTitle, simpleToolbarImage } from "../helpers";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";
import { useDebounce } from "../hooks/useDebounce";

export default function SimpleToolbar(props) {
  const classes = useStyles();
  const {
    // table,
    // tableHeader,
    // tableBody,
    // filename,
    // uploadDoctors,
    onFilter,
    // addButton,
    // onAdd,
    // hideExport,
    // labelAddButton,
    // deleteButton,
    // disabledDetele,
    // onDelete,
    // onUploadDoctors,
    // exportAll,
    // onExportDoctors,
    isOpen,
    setIsOpen,
    isOperator,
    // noExport,
    noSearchBar,
    placeholder = "¿Que estas buscando?",
    options,
  } = props;

  const theme = useTheme();

  // const getAssignmentsToExport = (e) => {
  //   e.preventDefault();
  //   const url = `https://unio-backend.herokuapp.com/api/v1/patients-export-orders`;
  //   const link = document.createElement("a");
  //   link.href = url;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const matchXs = useMediaQuery(theme.breakpoints.down("xs"));
  const showDrawerButton = useMediaQuery(theme.breakpoints.down("sm"));
  const [filter, setFilter] = useState("");
  const filterDebounced = useDebounce(filter, 500);
  // const onKeyPress = (key) => {
  //   if (key.charCode === 13) onFilter(filter);
  // };
  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if (noSearchBar) return;

    onFilter(filterDebounced);
  }, [filterDebounced]);

  // function handleDownloadExcel() {
  //   downloadExcel({
  //     fileName: filename,
  //     sheet: "Page1",
  //     tablePayload: {
  //       header: tableHeader,
  //       body: tableBody,
  //     },
  //   });
  // }
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <Grid container className={classes.ctn_toolbar} component={"header"}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <Box>
            {showDrawerButton ? (
              <IconButton
                onClick={() => setIsOpen(!isOpen)}
                style={{ padding: 4, paddingLeft: 0 }}
              >
                <MenuRoundedIcon color="secondary" fontSize="large" />
              </IconButton>
            ) : (
              <Box className={classes.imgContainer}>
                <img
                  src={simpleToolbarImage(isOperator)}
                  alt=""
                  style={{ width: "100%", objectFit: "cover" }}
                />
              </Box>
            )}
          </Box>
          <Box>
            <Typography className={classes.title} variant="h6" component={"h1"}>
              {simpleToolbarTitle(isOperator)}
            </Typography>
          </Box>
        </Grid>
        {!noSearchBar && (
          <Grid item xs={12}>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              // wrap="wrap"
              className={classes.options}
            >
              <Grid style={{ position: "relative", flex: 1 }}>
                <TextField
                  type={"text"}
                  name={"filter"}
                  value={filter}
                  fullWidth
                  placeholder={placeholder}
                  fontWeight="bold"
                  className={classes.input}
                  // onKeyPress={onKeyPress}
                  style={{ justifyContent: "flex-end" }}
                  iconComponent={() => <SearchIcon />}
                  // onClickIcon={() => onFilter(filter)}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </Grid>

              {/* PREV DESIGN OPTIONS */}
              {/* {!noExport && !hideExport && !matchXs && (
              // <ReactHtmlTableToExcel
              //   id={"botonExportarExcel"}
              //   className={classes.exportButton}
              //   table={table}
              //   filename={filename}
              //   sheet={"Pagina 1"}
              //   buttonText={"EXPORTAR"}
              // />
              // undefined
              <Button
                onClick={handleDownloadExcel}
                className={classes.options_buttons}
                size="small"
              >
                Exportar Excel
              </Button>
            )}
            {noExport && (
              <Button
                className={classes.options_buttons}
                onClick={getAssignmentsToExport}
                size="small"
              >
                Descargar
              </Button>
            )}
            {addButton && !matchXs && (
              <Button
                className={classes.options_buttons}
                onClick={() => onAdd()}
                size="small"
              >
                {labelAddButton ? labelAddButton : "Agregar"}
              </Button>
            )}
            {uploadDoctors && !matchXs && (
              <Button size="small" className={classes.options_buttons}>
                Cargar Médicos
                <input
                  type="file"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  hidden
                  onChange={(e) => onUploadDoctors(e)}
                />
              </Button>
            )}
            {exportAll && !matchXs && (
              <Button
                className={classes.options_buttons}
                size="small"
                onClick={() => onExportDoctors()}
              >
                Exportar todos
              </Button>
            )}
            {deleteButton && !matchXs && (
              <Button
                size="small"
                className={classes.options_buttons}
                disabled={disabledDetele}
                onClick={() => onDelete()}
              >
                Eliminar
              </Button>
            )} */}

              {/* HARDCODED PREV OPTIONS SIMPLE TOOLBAR */}
              {/* {!noSearchBar && !matchXs && (
                <>
                  <IconButton
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    style={{ padding: 0 }}
                  >
                    <MenuRoundedIcon fontSize="large" />
                  </IconButton>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {!noExport && !hideExport && !matchXs && (
                      <MenuItem
                        onClick={() => {
                          handleClose();
                          handleDownloadExcel();
                        }}
                      >
                        Exportar Excel
                      </MenuItem>
                    )}
                    {noExport && (
                      <MenuItem
                        onClick={(e) => {
                          handleClose();
                          getAssignmentsToExport(e);
                        }}
                      >
                        Descargar
                      </MenuItem>
                    )}
                    {addButton && !matchXs && (
                      <MenuItem
                        onClick={() => {
                          onAdd();
                          handleClose();
                        }}
                      >
                        {labelAddButton ? labelAddButton : "Agregar"}
                      </MenuItem>
                    )}
                    {uploadDoctors && !matchXs && (
                      <MenuItem
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Cargar Médicos
                        <input
                          type="file"
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          style={{
                            position: "absolute",
                            left: 0,
                            opacity: 0,
                          }}
                          onChange={(e) => {
                            handleClose();
                            onUploadDoctors(e);
                          }}
                        />
                      </MenuItem>
                    )}
                    {exportAll && !matchXs && (
                      <MenuItem
                        onClick={() => {
                          handleClose();
                          onExportDoctors();
                        }}
                      >
                        Exportar todos
                      </MenuItem>
                    )}
                    {deleteButton && !matchXs && (
                      <MenuItem
                        disabled={disabledDetele}
                        onClick={() => {
                          handleClose();
                          onDelete();
                        }}
                      >
                        Eliminar
                      </MenuItem>
                    )}
                  </Menu>
                </>
              )} */}

              {!matchXs && options && (
                <>
                  <IconButton
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    style={{ padding: 0 }}
                  >
                    <MenuRoundedIcon fontSize="large" />
                  </IconButton>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                    {options.map((opt) => (
                      <MenuItem
                        key={opt.label}
                        onClick={(e) => {
                          handleClose();
                          opt.action(e);
                        }}
                      >
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Menu>
                </>
              )}
            </Grid>
          </Grid>
        )}
        {/* </Grid> */}
      </Grid>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  // root: {
  //   paddingTop: theme.spacing(1),
  //   paddingBottom: theme.spacing(1),
  // },
  ctn_toolbar: {
    flexDirection: "colunm",
    // [theme.breakpoints.up("sm")]: {
    //   flexWrap: "nowrap",
    // },
  },
  imgContainer: {
    // [theme.breakpoints.down("sm")]: {
    //   flexBasis: 0,
    //   width: "max-content",
    // },
    [theme.breakpoints.up("sm")]: {
      width: 80,
      // height: 50,
    },
  },
  // importButton: {
  //   marginRight: theme.spacing(1),
  //   borderRadius: 25,
  // },
  paper: {
    paddingRight: theme.spacing(2),
  },
  // button: {
  //   margin: theme.spacing(1),
  //   borderRadius: 25,
  //   minWidth: 180,
  // },
  input: {
    height: 35,
    "& .MuiInputBase-root": {
      height: "100% !important",
    },
    //   [theme.breakpoints.down("xs")]: {
    //     margin: "20px 0 0 0",
    //   },
  },
  // exportButton: {
  //   margin: `0 ${theme.spacing(1)}px`,
  //   backgroundColor: theme.palette.secondary.main,
  //   color: "#FFF",
  //   border: 0,
  //   // borderRadius: 25,
  //   padding: "6px 16px",
  //   cursor: "pointer",
  //   boxShadow:
  //     "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
  //   boxSizing: "border-box",
  //   transition:
  //     "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  //   fontWeight: "500",
  //   lineHeight: 1.75,
  //   letterSpacing: "0.02857em",
  //   textTransform: "uppercase",
  //   minWidth: 180,
  // },
  title: {
    //   margin: "0 0 20px 0",
    color: theme.palette.text.primary,
    wordBreak: "break-word",
    //   fontSize: "1.125rem",
    //   fontWeight: "700",
    //   [theme.breakpoints.down("xs")]: {
    //     textAlign: "center",
    //     margin: 0,
    //   },
  },
  desktopOptions: {
    // height: "100%",
    // position: "relative",
    // [theme.breakpoints.down("xs")]: {
    //   padding: 0,
    // },
    // [theme.breakpoints.only("sm")]: {
    //   padding: "0 40px 0 0px",
    // },
    // [theme.breakpoints.up("sm")]: {
    //   padding: "0 0px 0 40px",
    // },
    // "& > div:nth-child(2)": {
    //   height: "60%",
    // },
    // [theme.breakpoints.up("md")]: {
    //   display: "flex",
    // },
  },
  options: {
    marginTop: 8,
    marginBottom: 12,
    gap: 8,
    justifyContent: "space-between",
  },
  options_buttons: {
    borderRadius: 25,
    minWidth: 160,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));
